/**
 * Created by henian.xu on 2018/4/20.
 *
 */

export { default as main } from './main';
